import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { TASK_CATEGORY } from "../apiRoutes";

const mutateToggleTaskCategory = async ({ id }: { id: string | number }) => {
	return await axiosAuth.patch(`${TASK_CATEGORY}${id}`);
};

const useToggleTaskCategoryMutation = (
	queryParams?: UseMutationOptions<
		any,
		Error,
		{
			id: string | number;
		},
		unknown
	>
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: mutateToggleTaskCategory,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({ queryKey: ["taskCategory"], exact: false });
			queryParams?.onSuccess?.(data, variables, context);
		},
		...queryParams,
	});
};

export default useToggleTaskCategoryMutation;
